import { ref } from 'vue'

/**
 * The server has stopped accepting this browser's log-in.
 *
 * A log-in lasts ten hours. When it ran out, BOB said nothing: screens failed one
 * by one, or dropped to the Log In page halfway through a form. It now says so the
 * way the tablet does (Mark, 2026-10-15): the refusal is noticed in ONE place,
 * where every request passes (plugins/auth-fetch.client.ts), and said in one
 * place, over whatever screen is up (components/app/SessionExpiredPanel.vue).
 *
 * The server is the only judge: the flag is raised by a 401, never by the
 * browser's clock, which can be wrong.
 */
export const sessionExpired = ref(false)

/**
 * Whether an answer means the log-in has run out.
 *
 * Only a request that CARRIED a log-in can have it refused, and the log-in
 * routes are left out: there a 401 is a wrong password, said by the Log In
 * screen itself, and a page opened with an old log-in simply goes to Log In.
 */
export function meansSessionExpired(path: string, status: number, carriedToken: boolean): boolean {
  if (status !== 401 || !carriedToken) return false
  return !/\/api\/auth(\/|$)/i.test(path)
}
